/**
 * SWW (SpellingWW) Module Seeds - DDD Canonical Location
 *
 * 24 families, all imports local (./SWW-*.json).
 */

import SWW_TT_STAM from './SWW-TT-STAM.json'
import SWW_TT_INV_JIJ from './SWW-TT-INV-JIJ.json'
import SWW_TT_INV_TRICK from './SWW-TT-INV-TRICK.json'
import SWW_TT_DSTAM from './SWW-TT-DSTAM.json'
import SWW_TT_MEERVOUD from './SWW-TT-MEERVOUD.json'
import SWW_TT_GEBIEDENDE from './SWW-TT-GEBIEDENDE.json'
import SWW_VT_ZWAK_KOF from './SWW-VT-ZWAK-KOF.json'
import SWW_VD_KOF from './SWW-VD-KOF.json'
import SWW_VT_STERK from './SWW-VT-STERK.json'
import SWW_VT_DUBBEL from './SWW-VT-DUBBEL.json'
import SWW_VD_HOMOFOON from './SWW-VD-HOMOFOON.json'
import SWW_VT_VZFS from './SWW-VT-VZFS.json'
import SWW_BN_VD_KORT from './SWW-BN-VD-KORT.json'
import SWW_BN_VD_DUBBEL from './SWW-BN-VD-DUBBEL.json'
import SWW_LEEN_ENG_STAM from './SWW-LEEN-ENG-STAM.json'
import SWW_LEEN_ENG_KOF from './SWW-LEEN-ENG-KOF.json'
import SWW_VT_ONREGELMATIG from './SWW-VT-ONREGELMATIG.json'
import SWW_VT_ZIJN_HEBBEN from './SWW-VT-ZIJN-HEBBEN.json'
import SWW_VD_STERK from './SWW-VD-STERK.json'
import SWW_TT_ZIJN_HEBBEN from './SWW-TT-ZIJN-HEBBEN.json'
import SWW_VD_ZONDER_GE from './SWW-VD-ZONDER-GE.json'
import SWW_VT_ZULLEN_KUNNEN from './SWW-VT-ZULLEN-KUNNEN.json'
import SWW_VD_HULPWW from './SWW-VD-HULPWW.json'
import SWW_LEEN_FRANS from './SWW-LEEN-FRANS.json'

const SWW_FAMILY_SEEDS = [
  { file: 'src/content/seeds/SWW/SWW-TT-STAM.json', data: SWW_TT_STAM },
  {
    file: 'src/content/seeds/SWW/SWW-TT-GEBIEDENDE.json',
    data: SWW_TT_GEBIEDENDE,
  },
  { file: 'src/content/seeds/SWW/SWW-VT-ZWAK-KOF.json', data: SWW_VT_ZWAK_KOF },
  { file: 'src/content/seeds/SWW/SWW-VD-KOF.json', data: SWW_VD_KOF },
  { file: 'src/content/seeds/SWW/SWW-TT-INV-JIJ.json', data: SWW_TT_INV_JIJ },
  { file: 'src/content/seeds/SWW/SWW-VT-STERK.json', data: SWW_VT_STERK },
  {
    file: 'src/content/seeds/SWW/SWW-VT-ONREGELMATIG.json',
    data: SWW_VT_ONREGELMATIG,
  },
  { file: 'src/content/seeds/SWW/SWW-TT-DSTAM.json', data: SWW_TT_DSTAM },
  {
    file: 'src/content/seeds/SWW/SWW-TT-INV-TRICK.json',
    data: SWW_TT_INV_TRICK,
  },
  { file: 'src/content/seeds/SWW/SWW-TT-MEERVOUD.json', data: SWW_TT_MEERVOUD },
  {
    file: 'src/content/seeds/SWW/SWW-TT-ZIJN-HEBBEN.json',
    data: SWW_TT_ZIJN_HEBBEN,
  },
  {
    file: 'src/content/seeds/SWW/SWW-VT-ZIJN-HEBBEN.json',
    data: SWW_VT_ZIJN_HEBBEN,
  },
  { file: 'src/content/seeds/SWW/SWW-VT-DUBBEL.json', data: SWW_VT_DUBBEL },
  { file: 'src/content/seeds/SWW/SWW-VD-HOMOFOON.json', data: SWW_VD_HOMOFOON },
  { file: 'src/content/seeds/SWW/SWW-VD-STERK.json', data: SWW_VD_STERK },
  { file: 'src/content/seeds/SWW/SWW-VT-VZFS.json', data: SWW_VT_VZFS },
  { file: 'src/content/seeds/SWW/SWW-BN-VD-KORT.json', data: SWW_BN_VD_KORT },
  {
    file: 'src/content/seeds/SWW/SWW-BN-VD-DUBBEL.json',
    data: SWW_BN_VD_DUBBEL,
  },
  {
    file: 'src/content/seeds/SWW/SWW-LEEN-ENG-STAM.json',
    data: SWW_LEEN_ENG_STAM,
  },
  {
    file: 'src/content/seeds/SWW/SWW-LEEN-ENG-KOF.json',
    data: SWW_LEEN_ENG_KOF,
  },
  {
    file: 'src/content/seeds/SWW/SWW-VD-ZONDER-GE.json',
    data: SWW_VD_ZONDER_GE,
  },
  {
    file: 'src/content/seeds/SWW/SWW-VT-ZULLEN-KUNNEN.json',
    data: SWW_VT_ZULLEN_KUNNEN,
  },
  { file: 'src/content/seeds/SWW/SWW-VD-HULPWW.json', data: SWW_VD_HULPWW },
  {
    file: 'src/content/seeds/SWW/SWW-LEEN-FRANS.json',
    data: SWW_LEEN_FRANS,
  },
] as const

const allQuestions = SWW_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'SpellingWW' as const,
  moduleCode: 'SWW',
  version: '5.3-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
